export const APT_STATUS_COLORS = {
  available: 'bg-emerald-50 text-emerald-700',
  matched: 'bg-slate-100 text-slate-700',
};

export function formatAptRent(apt) {
  const rent = Number(apt?.rent);
  if (!Number.isFinite(rent) || rent <= 0) return '—';
  return `CHF ${Math.round(rent).toLocaleString()}`;
}

export function formatAptRooms(apt) {
  const rooms = apt?.rooms;
  if (rooms === null || rooms === undefined || rooms === '') return '—';
  return String(rooms);
}

export function formatAptSize(apt) {
  const size = Number(apt?.size);
  if (!Number.isFinite(size) || size <= 0) return '—';
  return `${size}m²`;
}

export function pmLabel(pm) {
  if (!pm) return '—';
  return pm.company || `${pm.first_name || ''} ${pm.last_name || ''}`.trim() || '—';
}

export function sourceLabel(source, t) {
  if (!source) return '—';
  const key = `admin.apt.source.${source}`;
  const translated = t(key);
  return translated !== key ? translated : source.replace(/_/g, ' ');
}

export function statusLabel(status, t) {
  if (status === 'matched') return t('admin.apt.statusRented');
  if (status === 'available') return t('admin.apt.statusAvailable');
  return status || '—';
}
